import React from 'react';
import { Box } from 'src/components/matchbox';

const Divider = (): JSX.Element => <Box as="hr" margin="0" />;

export default Divider;
